import AbstractTokenStrategy from './abstractTokenStrategy';

class ArtTokenStrategy extends AbstractTokenStrategy {
  constructor() {
    super('users-auth-token');
  }
}

export default ArtTokenStrategy;
